/* global google */
import React, { Component } from 'react';
import svgChamaLogo from '@chama/statics/assets/svg/logo-blue.svg';
import omit from 'lodash.omit';
import './index.css';

// Old Key:
// const googleMapsApiKey = 'AIzaSyAmHmMEGxOGWFz7D8QD4sionV6lOBpB8co';

const googleMapsApiKey = process.env.CHAMA_APP_GOOGLE_MAPS_API_KEY;
const googleMapsStyles = [
  // don't show points of interest like "Anne Frank House" etc
  {
    featureType: 'poi',
    stylers: [{ visibility: 'off' }],
  },
  // don't show names of busstops etc
  {
    featureType: 'transit',
    stylers: [{ visibility: 'off' }],
  },
  // don't show road icons like 'S100' etc
  {
    featureType: 'road',
    elementType: 'labels.icon',
    stylers: [{ visibility: 'off' }],
  },
];

class Map extends Component {
  static googleMapsApiLoadedPromise;

  // load google maps sdk once per app
  loadGoogleMapsSdk() {
    if (!Map.googleMapsApiLoadedPromise) {
      Map.googleMapsApiLoadedPromise = new Promise(resolve => {
        const ref = window.document.getElementsByTagName('script')[0];
        const script = window.document.createElement('script');
        const onLoadCallbackName = 'googleMapsApiOnLoad';
        window[onLoadCallbackName] = resolve;
        // NOTE: this is the latest 'release' version as of 2017/3/16
        // @see https://developers.google.com/maps/documentation/javascript/reference
        const apiVersion = '3';
        script.src = `https://maps.googleapis.com/maps/api/js?v=${apiVersion}&key=${googleMapsApiKey}&callback=${onLoadCallbackName}`;
        script.async = true;
        ref.parentNode.insertBefore(script, ref);
      });
    }

    return Map.googleMapsApiLoadedPromise;
  }

  componentWillMount() {
    this.loadGoogleMapsSdk();
  }

  componentDidMount() {
    const { markers } = this.props;

    this.loadGoogleMapsSdk().then(() => {
      const bounds = new google.maps.LatLngBounds();
      markers.forEach(({ lat, lng }) => {
        bounds.extend(new google.maps.LatLng(lat, lng));
      });
      const map = new google.maps.Map(this.div, {
        styles: googleMapsStyles,
        disableDefaultUI: false,
        zoomControl: true,
      });
      map.setCenter(bounds.getCenter());
      map.fitBounds(bounds);
      markers.forEach(({ lat, lng, type = 'normal' }) => {
        const icon = {
          url: type === 'chama' ? svgChamaLogo : undefined,
          scaledSize: new google.maps.Size(35, 40),
        };

        new google.maps.Marker({
          position: { lat, lng },
          map,
          icon,
        });
      });
    });
  }

  render() {
    const otherProps = omit(this.props, 'markers');
    return (
      <div
        className="Map"
        ref={div => {
          this.div = div;
        }}
        {...otherProps}
      >
        Loading map...
      </div>
    );
  }
}

const StaticMap = ({ width, height, lat, lng, ...otherProps }) => {
  const params = [
    ['key', googleMapsApiKey],
    ['size', `${width}x${height}`],
    ['zoom', 17],
    ['markers', `color:red|${lat},${lng}`],
  ];
  // convert Google Maps JS SDK style definitions into Google Maps static maps style
  // string formats.
  // @see https://developers.google.com/maps/documentation/javascript/style-reference
  // @see https://developers.google.com/maps/documentation/static-maps/styling
  googleMapsStyles.forEach(({ featureType, elementType, stylers }) => {
    const styleParts = [];
    if (featureType) {
      styleParts.push(`feature:${featureType}`);
    }
    if (elementType) {
      styleParts.push(`element:${elementType}`);
    }
    stylers.forEach(styler => {
      Object.keys(styler).forEach(style => {
        const value = styler[style];
        styleParts.push(`${style}:${value}`);
      });
    });
    params.push(['style', styleParts.join('|')]);
  });
  const query = params
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
    .join('&');
  const url = `https://maps.googleapis.com/maps/api/staticmap?${query}`;
  return <img width={width} height={height} src={url} alt="map" {...otherProps} />;
};

export { Map, StaticMap };



// WEBPACK FOOTER //
// ../ui-components/components/GoogleMaps/index.jsx